<template>
  <div class="order-container">
    <a-list item-layout="vertical"
      size="large"
      class="order-container"
      :pagination="pagination"
      :data-source="data"
      :locale="{ emptyText: '暂无数据'}"
    >
      <template slot="header" >
        <div class="order-header">
          <span class="order-item" >商品名称</span> 
          <span class="order-item" >{{isSupplier?"进货价":"渠道价"}}(元)
            <a-tooltip placement="bottom" 
              :overlayStyle="{}"
              :getPopupContainer="
              triggerNode => {
                return triggerNode.parentNode || document.body;
              }"
            >
              <span slot="title">提供给渠道商的价格</span>
              <a-icon type="exclamation-circle" />
            </a-tooltip>
          </span>
          <span class="order-item" >数量</span>
          <span class="order-item" >供应商名</span>
          <span class="order-item" >渠道商名</span>
          <span class="order-item" >合计{{isSupplier?"进货":"渠道"}}金额(元)</span>
          <span class="order-item" >买家</span>
          <span class="order-item" >订单状态</span>
          <span class="order-item" >操作</span>
        </div>
      </template>
      <a-list-item slot="renderItem" slot-scope="item, index" >
        <div class="order-time">
          <span>订单编号：{{item.orderNum}}</span>
          <span>创建时间：{{item.submitDateTimeLabel}}</span>
          <div style="display:inline-block;padding-left:10px" v-if="item.creditStatus&&item.creditStatus!='1'">
            <div class="img-center" >
              <img src="../assets/img/xin.png" v-if="item.creditStatus!='1'"/>{{item.creditStatus|creditFormat}}
              <a-tooltip placement="bottom"
                :getPopupContainer="
                triggerNode => {
                  return triggerNode.parentNode || document.body;
                } "
                >
                <span slot="title">{{item.creditStatus|creditTip}}</span>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </div>
          </div>
          
        </div>
        <div class="order-detail">
          <span class="order-item" >
            <div class="mdseName">
              <img :src="item.skuImgPath" alt="">
              <div class="mdseName-right">
                <div :title="item.mdseName">{{item.mdseName}}</div>
                <div :title="item.variantNameObject.values|variantF">{{item.variantNameObject.values|variantF}}</div>
              </div>
            </div>
          </span>
          <span class="order-item" >{{isSupplier?item.supplyPrice:item.distributePrice|toFixed2}}</span>
          <span class="order-item" >{{item.quantity}}</span>
          <span class="order-item" :title="item.supplierAlias">{{item.supplierAlias}}</span>
          <span class="order-item" :title="item.distributorAlias">{{item.distributorAlias}}</span>
          <span class="order-item" >{{isSupplier?item.supplierAmount:item.quantity*item.distributePrice|toFixed2}}</span>
          <span class="order-item" >
            <span :title="item.buyer">{{item.buyer}}</span>  <br>
            <span :title="item.buyerPhoneNum">{{item.buyerPhoneNum}}</span>
          </span>
          <span class="order-item" >{{item.orderStatus|orderFormat}} <br/>{{item.orderStatus|orderDFormat}}</span>
          <span class="order-item" @click="openModal(item.orderNum)"><a >查看详情</a> </span>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
	name:"OrderList",
  props:{
		data:{
			type:Array,
			default:()=>[]
    },
    orderType:{
      type:String,
      default:"1",
    },
		pagination:{
			type:Object,
			default:()=>{}
		},
  },
  computed:{
    isSupplier(){
      let value = this.orderType;
      if (value=='5'||value=='6'||value=='7') {
        return true;
      }
      return false
    },
  },
	filters:{
    orderFormat(value){
      switch (value) {
          case 10:return "待发货";
          case 20:return "已发货";
          case 30:return "已完成";
          case 40:return "退款退货";
          case 45:return "退款退货";
          case 50:return "换货";
          case 52:return "换货";
          case 54:return "换货";
          case 56:return "换货";
          default:return "";
      }
    },
    orderDFormat(value){
      switch (value) {
        case 40:return "供应商待收货";
        case 45:return "已完成";
        case 50:return "供应商待收货";
        case 52:return "供应商待发货";
        case 54:return "供应商已发货";
        case 56:return "已完成";
        default:return "";
      }
    },
    creditTip (value){
      switch (value) {
        case 2: return '该笔订单金额全部从渠道商授信额度中扣除';
        case 3: return '该笔订单金额部分从渠道商授信额度中扣除';
      }
    },
		variantF(value){
      if (!(value instanceof Array)) {
        return "--";
      }
			return value.join("、")
		},
		creditFormat(value){
			switch (value) {
				case 1: return '非授信';
				case 2: return '授信';
				case 3: return '部分授信';
			}
		},
	},
  methods:{
    openModal(id) {
      let orderType = this.orderType;
      if (orderType==2||orderType==3||orderType==4) {
        this.$router.push({ name: "order-channel", query: { id,orderType} });
        return
      }else if (orderType==5||orderType==6) {
        this.$router.push({ name: "order-advance", query: { id,orderType} });
        return
      }else if (orderType==7) {
        this.$router.push({ name: "order-after", query: { id,orderType} });
        return
      }
      this.$router.push({ name: "order-detail", query: { id,orderType} });
    },   
  }
};
</script>
<style lang="less" scoped>
/deep/.ant-tooltip {
  max-width: none;
}
/deep/.ant-list-lg .ant-list-item {
    padding-top: 0;
}
.ant-list-split .ant-list-item {
		border: 1px solid #e8e8e8;
		padding-bottom: 0;
    margin-bottom: 12px;
}
/deep/.ant-list-split .ant-list-header {
		margin-bottom: 12px;
		padding: 0;
    background-color: #FAFAFA;
}

.order-container {
  .mdseName{
    display: flex;
    align-items:center;
    .mdseName-right{
      width: calc(100% - 68px);
      div{
        width: 100%;
        white-space:nowrap;
        overflow:hidden;
        text-overflow:ellipsis;
      }
    }
    img{
      margin-right: 8px;
      width: 60px;
      height: 60px;
    }
  }
  .order-detail,
  .order-header {
    padding: 10px 24px;
    padding-right: 0;
    .order-item {
      display: inline-block;
      font-size: 14px;
      width: 10%;
    }
    .order-item:first-child {
      width: 21%;
    }
    .order-item:nth-child(3) {
      width: 7%;
    }
    .order-item:nth-child(6) {
      width: 13%;
    }
    .order-item:last-child {
      width: 7%;
    }
  }

  .order-time {
    height: 48px;
    padding: 12px 24px;
    background-color: #fafafa;
    span {
      display: inline-block;
      padding-right: 32px;
    }
  }
  .order-header {
    height: 54px;
    .order-item {
      vertical-align: middle;
      text-align: left;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .order-detail {
    display: flex;
    align-items: center;
    .order-item{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.img-center{
  position: relative;
  img{
    position: absolute;
    bottom: 0;
    left: -25px;
    right: 0;
    width: 18px;
    height: 18px;
  }
}
</style>
